import { cloneDeep } from 'lodash';
import moment from 'moment-timezone';

import { LanguageDefaults } from '../../../../voice-response-command/vrc-audio-metadata/language-defaults';
import { MessageTemplateContextObj } from '../message-template-context-obj';

export const makeContextForDuration = (
  start: moment.Moment,
  end: moment.Moment,
  language: LanguageDefaults,
): MessageTemplateContextObj => {
  const localizedDuration = moment.duration(cloneDeep(end).diff(start)).locale(language.getShortCode());

  const result = {} as MessageTemplateContextObj;
  result.days = localizedDuration.days();
  result.hours = localizedDuration.hours();
  result.minutes = localizedDuration.minutes();
  result.seconds = localizedDuration.seconds();

  return result;
};
